export default __webpack_public_path__ + "static/media/lera.75185b73.png";